import { allActiveGroupByVariables } from './findActiveGroupByVariablesByUid.js';
import { SceneQueryRunner } from '../../querying/SceneQueryRunner.js';
import { sceneGraph } from '../../core/sceneGraph/index.js';
import { MultiValueVariable } from '../variants/MultiValueVariable.js';
import { map, of, from, mergeMap, take } from 'rxjs';
import { getDataSource } from '../../utils/getDataSource.js';
import { renderSelectForVariable } from '../components/VariableValueSelect.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class GroupByVariable extends MultiValueVariable {
  constructor(initialState) {
    super(__spreadProps(__spreadValues({
      isMulti: true,
      name: "",
      value: [],
      text: [],
      options: [],
      datasource: null,
      baseFilters: [],
      applyMode: "auto",
      layout: "horizontal",
      type: "groupby"
    }, initialState), {
      noValueOnClear: true
    }));
    this._getKeys = async (ds) => {
      var _a, _b, _c;
      const override = await ((_b = (_a = this.state).getTagKeysProvider) == null ? void 0 : _b.call(_a, this, null));
      if (override && override.replace) {
        return override.values;
      }
      if (this.state.defaultOptions) {
        return this.state.defaultOptions.concat((_c = override == null ? void 0 : override.values) != null ? _c : []);
      }
      if (!ds.getTagKeys) {
        return [];
      }
      const queries = this._getSceneQueries();
      const otherFilters = this.state.baseFilters || [];
      let keys = await ds.getTagKeys({ filters: otherFilters, queries });
      if (override) {
        keys = keys.concat(override.values);
      }
      const tagKeyRegexFilter = this.state.tagKeyRegexFilter;
      if (tagKeyRegexFilter) {
        keys = keys.filter((f) => f.text.match(tagKeyRegexFilter));
      }
      return keys;
    };
    this.addActivationHandler(() => {
      allActiveGroupByVariables.add(this);
      return () => allActiveGroupByVariables.delete(this);
    });
  }
  validateAndUpdate() {
    return this.getValueOptions({}).pipe(
      map((options) => {
        this._updateValueGivenNewOptions(options);
        return {};
      })
    );
  }
  _updateValueGivenNewOptions(options) {
    const { value: currentValue, text: currentText } = this.state;
    const stateUpdate = {
      options,
      loading: false,
      value: currentValue != null ? currentValue : [],
      text: currentText != null ? currentText : []
    };
    this.setState(stateUpdate);
  }
  getValueOptions(args) {
    if (this.state.defaultOptions) {
      return of(
        this.state.defaultOptions.map((o) => ({
          label: o.text,
          value: String(o.value)
        }))
      );
    }
    this.setState({ loading: true, error: null });
    return from(
      getDataSource(this.state.datasource, {
        __sceneObject: { text: "__sceneObject", value: this }
      })
    ).pipe(
      mergeMap((ds) => {
        return from(this._getKeys(ds)).pipe(
          take(1),
          mergeMap((data) => {
            const a = data.map((i) => {
              return {
                label: i.text,
                value: i.value ? String(i.value) : i.text
              };
            });
            return of(a);
          })
        );
      })
    );
  }
  getDefaultMultiState(options) {
    return { value: [], text: [] };
  }
  _getSceneQueries() {
    const runners = sceneGraph.findAllObjects(
      this.getRoot(),
      (o) => o instanceof SceneQueryRunner
    );
    const applicableRunners = runners.filter((r) => {
      var _a, _b;
      return ((_a = r.state.datasource) == null ? void 0 : _a.uid) === ((_b = this.state.datasource) == null ? void 0 : _b.uid);
    });
    if (applicableRunners.length === 0) {
      return [];
    }
    const result = [];
    applicableRunners.forEach((r) => {
      result.push(...r.state.queries);
    });
    return result;
  }
}
GroupByVariable.Component = GroupByVariableRenderer;
function GroupByVariableRenderer({ model }) {
  return renderSelectForVariable(model);
}

export { GroupByVariable, GroupByVariableRenderer };
//# sourceMappingURL=GroupByVariable.js.map
